import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {frnt} from '@frnt/base/themes'
import {Grid as RmwcGrid} from '@rmwc/grid'
import '@rmwc/grid/styles'

const StyledRmwcGrid = styled(RmwcGrid)`
  @media (max-width: 599px) {
    &&& {
      box-sizing: initial;
      margin: initial;
      padding: initial;
    }
  }
  @media (min-width: 600px) and (max-width: 839px) {
    &&& {
      box-sizing: initial;
      margin: initial;
      padding: initial;
    }
  }
  @media (min-width: 840px) {
    &&& {
      box-sizing: initial;
      margin: initial;
      padding: initial;
    }
  }
  @media ${frnt.devicePhone}, ${frnt.deviceTablet}, ${frnt.deviceDesktop} {
    &&& {
      box-sizing: border-box;
      margin: 0 auto;
    }
  }
  @media ${frnt.devicePhone} {
    &&& {
      padding: var(--mdc-layout-grid-margin-phone, 16px);
    }
  }
  @media ${frnt.deviceTablet} {
    &&& {
      padding: var(--mdc-layout-grid-margin-tablet, 16px);
    }
  }
  @media ${frnt.deviceDesktop} {
    &&& {
      padding: var(--mdc-layout-grid-margin-desktop, 24px);
    }
  }
`

const Grid = ({children, ...otherProps}) => <StyledRmwcGrid {...otherProps}>{children}</StyledRmwcGrid>

Grid.propTypes = {
  children: PropTypes.any
}

export {Grid}
